import React from "react";
import { Route, Routes } from "react-router-dom";
import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";
import Home from "../Components/home/Home";
import Profile from "../pages/profile/Profile";
import CreateRequest from "../pages/request/CreateRequest";
import Background from "../pages/auth/Background";
import AllRequest from "../pages/request/ListRequest";
import SSO from "../pages/auth/SSO";
//import RestartPassword from "../pages/auth/RestartPassword";
import Personal from "../Components/personalItem/Personal";
import PersonalTable from "../Components/personalItem/PersonalTable";
import Vehicles from "../Components/vehicles/Vehicles";
import VehicleTable from "../Components/vehicles/VehicleTable";
import HomeIFrame from "../pages/firstPage/HomeiFrame";
import PasswordRecovery from "../pages/auth/RecoveryPasword"
import ResetPassword from "../pages/auth/ResetPassword"


const AllRoutes = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />}>
          <Route path="/request/new" element={<CreateRequest />} />
          <Route path="/request/all" element={<AllRequest />} />
          <Route path="/request/approve" element={<AllRequest />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/request/personal" element={<PersonalTable />} />
          <Route path="/request/addPersonal" element={<Personal />} />
          <Route path="/request/addVehicles" element={<Vehicles />} />
          <Route path="/request/vehicles" element={<VehicleTable />} />
          <Route path="/instructive" element={<HomeIFrame />} />
        </Route>
        <Route path="/login" element={<Background component ={ <Login/> } />} />
        <Route path="/recovery-password" element={<Background component ={ <PasswordRecovery/> } />} />
        <Route path="/reset-password" element={<Background component ={ <ResetPassword/> } />} />
        <Route path="/sso" element={<Background component ={ <SSO/> } />} />
        {/* <Route path="/resetPassword" element={<Background component={<RestartPassword />}/>} /> */}
        <Route path="/register" element={<Background component={<Register adMesagge={"Confirma registro?"} suMessage={'Registro satisfactorio'}/>} />} />
      </Routes>
    </>
  );
}

export default AllRoutes;